import React, { useEffect, useState } from "react";
import PageTitle from "../../Module/pageTitle";
import SubmitButton from "../../Component/SubmitButton";
import LabelField from "../../Component/labelField";
import Dropdown from "../../Component/dropdown";
import ImagePickerAndViewer from "../../Component/imagePickerAndViewer";
import {
  length_One,
  length_Three,
  pdf_size_1MB,
  validateIsFileImageType,
  validateIsNumberOnly,
} from "../../Utils/validators";
import { showErrorSnackbar } from "../../Action/snackbarAction";
import { validateIsFileImageTypeErrMsg } from "../../Utils/errorMsg";
import InputField from "../../Component/inputField";
import {
  getExamListNew,
  getParentCourseNew,
  getState,
  offerPopupAdd,
  offerPopupTypes,
  uploadPopupImg,
} from "../../Action/courseAction";
import { useDispatch } from "react-redux";
import ToggleSwitchBtn from "../../Component/toggleSwitchBtn";
import DropdownType from "../../Component/dropdownType";
import { getSubExam } from "../../Action/adminPanelAction";
import SquareCheckBox from "../../Component/SquareCheckBox";
const allTypes = [
  { _id: 1, name: "PAID" },
  { _id: 2, name: "FREE" },
  { _id: 3, name: "All" },
];
const COLOR_PICKER_TYPE_IDS = [9, 1, 2, 6, 5];
const HEX_COLOR_REGEX = /^#([0-9A-Fa-f]{6})$/;
const isValidHexColor = (value) => HEX_COLOR_REGEX.test(value);

const normalizeHexInput = (value) => {
  if (!value) return null;
  const trimmed = value.trim();
  const withHash = trimmed.startsWith("#") ? trimmed : `#${trimmed}`;
  return isValidHexColor(withHash) ? withHash : null;
};
import DeleteForeverIcon from "@mui/icons-material/DeleteForever";
import AddMorebtn from "../../Component/addMoreBtn";
import HighlightOffIcon from "@mui/icons-material/HighlightOff";
const AddAllPopup = () => {
  const dispatch = useDispatch();
  const [popupTypes, setPopupTypes] = useState([]);
  const [examList, setExamList] = useState([]);
  const [parentCourseList, setParentCourseList] = useState([]);
  const [parentCourseVal, setParentCourseVal] = useState("");
  const [popupTypesName, setPopupTypesName] = useState("");
  const [examName, setExamName] = useState("");
  const [subExamList, setSubExamList] = useState([]);
  const [subExamName, setSubExamName] = useState("");
  const [priorityOrder, setPriorityOrder] = useState("");
  const [headingText, setHeadingText] = useState("");
  const [popUrl, setPopUrl] = useState("");
  const [selectedImage, setSelectedImage] = useState("");
  const [selectedImage1, setSelectedImage1] = useState("");
  const [selectedImageView, setSelectedImageView] = useState("");
  const [selectedImageView1, setSelectedImageView1] = useState("");
  const [selectedImageMobile, setSelectedImageMobile] = useState("");
  const [selectedImageMobile1, setSelectedImageMobile1] = useState("");
  const [selectedImageMobilePrev, setSelectedImageMobilePrev] = useState("");
  const [selectedImageMobilePrev1, setSelectedImageMobilePrev1] = useState("");
  const [paidUser, setPaidUser] = useState(false);
  const [status, setStatus] = useState(false);
  const [stateId, setStateId] = useState(true);
  const [statesList, setStatesList] = useState([]);
  const [selectedState, setSelectedState] = useState([]);
  const [gender, setGender] = useState("");
  const [selectedType, setSelectedType] = useState("");
  const [primaryColor, setPrimaryColor] = useState("");
  const [primaryColorText, setPrimaryColorText] = useState("");
  const [secondaryColor, setSecondaryColor] = useState("");
  const [secondaryColorText, setSecondaryColorText] = useState("");
  const [spinnerColor, setSpinnerColor] = useState(["", "", ""]);
  const [spinnerColorText, setSpinnerColorText] = useState(["", "", ""]);
  const initialPopupImage = {
    webImage: "",
    webImagePreview: "",
    appImage: "",
    appImagePreview: "",
    order: "",
  };

  const [popupImageArr, setPopupImageArr] = useState([initialPopupImage]);
  useEffect(() => {
    dispatch(
      getExamListNew((res) => {
        setExamList(res);
      }),
    );
    dispatch(
      offerPopupTypes((res) => {
        if (res) {
          setPopupTypes(res);
        }
      }),
    );
    dispatch(
      getState((res) => {
        let tempStates =
          res?.map((item) => {
            return {
              _id: item?._id,
              name: item?.name,
              isSelected: false,
            };
          }) || [];
        tempStates.unshift({
          _id: "1",
          name: "SELECT ALL",
          isSelected: false,
        });

        setStatesList(tempStates);
      }),
    );
  }, []);

  const genderList = [
    { _id: 1, name: "MALE" },
    { _id: 2, name: "FEMALE" },
  ];

  const showsPrimarySecondaryColor = COLOR_PICKER_TYPE_IDS.includes(
    popupTypesName?._id,
  );
  const showsSpinnerColor = popupTypesName?._id === 9;

  const onSelectedState = (event, index) => {
    let newArray = [...statesList];

    if (index === 0) {
      const isAllSelected = event.target.checked;
      newArray = newArray.map((s) => ({ ...s, isSelected: isAllSelected }));
    } else {
      newArray[index].isSelected = event.target.checked;

      const allSelected = newArray.slice(1).every((s) => s.isSelected);
      newArray[0].isSelected = allSelected;
    }

    setStatesList(newArray);
    const selectedStateIds = newArray
      .filter((state, i) => i !== 0 && state.isSelected)
      .map((state) => state._id);

    setSelectedState(selectedStateIds);
  };
  const onChangeSpinnerColor = (index, value) => {
    setSpinnerColor((prev) => {
      const updated = [...prev];
      updated[index] = value;
      return updated;
    });
  };

  // Picker changed -> it's always a full valid hex, so push it straight to both.
  const onPrimaryColorPickerChange = (value) => {
    setPrimaryColor(value);
    setPrimaryColorText(value);
  };
  // Text typed -> always reflect what the user typed, and only push it to the
  // picker/canonical value once it resolves to a valid hex code.
  const onPrimaryColorTextChange = (value) => {
    setPrimaryColorText(value);
    const normalized = normalizeHexInput(value);
    if (normalized) {
      setPrimaryColor(normalized);
    }
  };
  // NEW: Cancel button handler — resets Primary Color back to fully empty.
  const handleCancelPrimaryColor = () => {
    setPrimaryColor("");
    setPrimaryColorText("");
  };

  const onSecondaryColorPickerChange = (value) => {
    setSecondaryColor(value);
    setSecondaryColorText(value);
  };
  const onSecondaryColorTextChange = (value) => {
    setSecondaryColorText(value);
    const normalized = normalizeHexInput(value);
    if (normalized) {
      setSecondaryColor(normalized);
    }
  };
  const handleCancelSecondaryColor = () => {
    setSecondaryColor("");
    setSecondaryColorText("");
  };

  const onSpinnerColorPickerChange = (index, value) => {
    onChangeSpinnerColor(index, value);
    setSpinnerColorText((prev) => {
      const updated = [...prev];
      updated[index] = value;
      return updated;
    });
  };
  const onSpinnerColorTextChange = (index, value) => {
    setSpinnerColorText((prev) => {
      const updated = [...prev];
      updated[index] = value;
      return updated;
    });
    const normalized = normalizeHexInput(value);
    if (normalized) {
      onChangeSpinnerColor(index, normalized);
    }
  };
  // NEW: Cancel button handler — resets just this one Spinner swatch (by
  // index) back to fully empty, leaving the other two untouched.
  const handleCancelSpinnerColor = (index) => {
    setSpinnerColor((prev) => {
      const updated = [...prev];
      updated[index] = "";
      return updated;
    });
    setSpinnerColorText((prev) => {
      const updated = [...prev];
      updated[index] = "";
      return updated;
    });
  };
  const onPressAddPopupImage = () => {
    setPopupImageArr([...popupImageArr, { ...initialPopupImage }]);
  };

  const handleClosePopupImage = (index) => {
    const newArray = [...popupImageArr];

    if (index > -1) {
      newArray.splice(index, 1);
    }

    setPopupImageArr(newArray);
  };

  const onChangePopupImage = (index, value, key) => {
    let newArray = JSON.parse(JSON.stringify(popupImageArr));

    newArray[index][key] = value;

    setPopupImageArr(newArray);
  };
  const handlePopupWebImageChange = (e, index) => {
    const file = e.target.files[0];

    if (!file) return;

    const validTypes = ["image/jpeg", "image/jpg", "image/png", "image/webp"];

    if (!validTypes.includes(file.type)) {
      return;
    }

    const reader = new FileReader();

    reader.onloadend = () => {
      setPopupImageArr((prev) =>
        prev.map((item, i) =>
          i === index
            ? {
                ...item,
                webImagePreview: reader.result,
              }
            : item,
        ),
      );
    };

    reader.readAsDataURL(file);

    dispatch(
      uploadPopupImg(file, (response) => {
        setPopupImageArr((prev) =>
          prev.map((item, i) =>
            i === index
              ? {
                  ...item,
                  webImage: response?.fullPath,
                }
              : item,
          ),
        );
      }),
    );
  };

  const handlePopupAppImageChange = (e, index) => {
    const file = e.target.files[0];

    if (!file) return;

    // Keep the same validation you already use
    const validTypes = ["image/jpeg", "image/jpg", "image/png", "image/webp"];

    if (!validTypes.includes(file.type)) {
      // use your existing snackbar/error logic here
      return;
    }

    const reader = new FileReader();

    reader.onloadend = () => {
      setPopupImageArr((prev) =>
        prev.map((item, i) =>
          i === index
            ? {
                ...item,
                appImagePreview: reader.result,
              }
            : item,
        ),
      );
    };

    reader.readAsDataURL(file);

    dispatch(
      uploadPopupImg(file, (response) => {
        setPopupImageArr((prev) =>
          prev.map((item, i) =>
            i === index
              ? {
                  ...item,
                  appImage: response?.fullPath,
                }
              : item,
          ),
        );
      }),
    );
  };
  const renderAddPopup = () => {
    return (
      <div className="col-md-12">
        <div className="col-md-6 d-flex mb-2 align-items-center">
          <LabelField labelName={"Type"} isRequired />
          <DropdownType
            setInputText={(value) => onPopUpChange(value)}
            value={popupTypesName}
            options={popupTypes}
            labelName="Select Type"
            Isrequired={true}
          />
        </div>
        {(popupTypesName?._id === 3 || popupTypesName?._id === 7) && (
          <>
            <div className="col-md-6 d-flex mb-2 align-items-center">
              <LabelField labelName={"Exam Name"} isRequired={true} />
              <Dropdown
                setInputText={(value) => onChangeExamName(value)}
                value={examName}
                options={examList}
                labelName="Select Exam Name"
              />
            </div>
            {subExamList?.length > 0 ? (
              <div className="col-md-6 d-flex mb-2 align-items-center">
                <LabelField labelName={"Sub Exam Name"} />
                <Dropdown
                  labelName={"Sub Exam Name"}
                  placeholder={"select Sub Exam name"}
                  setInputText={(value) => onChangeSubExam(value)}
                  value={subExamName}
                  options={subExamList}
                />
              </div>
            ) : null}
            <div className="col-md-6 d-flex mb-2 align-items-center">
              <LabelField labelName={"Exam Stream"} isRequired={true} />
              <Dropdown
                setInputText={(value) => onChangeParentCourse(value)}
                value={parentCourseVal}
                options={parentCourseList}
                labelName="Select Exam Stream"
              />
            </div>
            <div className="col-md-6 d-flex mb-2 align-items-center">
              <LabelField labelName={"Select User"} />
              <Dropdown
                setInputText={(value) => setSelectedType(value)}
                value={selectedType}
                options={allTypes}
                labelName="Select User"
              />
            </div>
            <div className="col-md-6 d-flex align-items-center mb-2">
              <LabelField labelName={"Navigation Url"} isRequired={true} />
              <InputField
                placeholder={"Enter Navigation Url"}
                setInputText={(value) => onChangeText("url", value)}
                value={popUrl}
                maxlength={600}
                minlength={length_One}
              />
            </div>
          </>
        )}
        {popupTypesName?._id === 4 && (
          <div className="col-md-6 d-flex mb-2 align-items-center">
            <LabelField labelName={"Select User"} />
            <Dropdown
              setInputText={(value) => setSelectedType(value)}
              value={selectedType}
              options={allTypes}
              labelName="Select User"
            />
          </div>
        )}

        {popupTypesName?._id === 4 && (
          <>
            <div className="col-md-6 d-flex mb-2 justify-content-start align-items-center">
              <ToggleSwitchBtn
                labelName={"State Id"}
                getToggleval={(value) => changeStateId(value)}
                isActive={stateId}
                // Isrequired={true}
              />
            </div>
            {stateId ? (
              <div className="d-flex mb-2 align-items-start">
                <LabelField labelName={"Select State"} isRequired={true} />
                {statesList?.length > 0 ? (
                  <div className="d-flex align-items-start">
                    <div className="border rounded p-2 mx-1 w-100 row">
                      {statesList.map((c, index) => {
                        return (
                          <div
                            className={`d-flex align-items-center ${
                              c?.name === "SELECT ALL" ? "col-12" : "col-6"
                            }`}
                            key={index}
                          >
                            <SquareCheckBox
                              id={c?._id}
                              type="checkbox"
                              name={"Exam Name"}
                              value={c?.name}
                              checked={c?.isSelected}
                              onChange={(event) => {
                                onSelectedState(event, index);
                              }}
                              // labelName={c?.name}
                            />
                            <p
                              className="ms-2 cursor m-0"
                              // onClick={() => onChangeExam(c)}
                            >
                              {c?.name}
                              <span className="ms-2"></span>
                            </p>
                          </div>
                        );
                      })}
                    </div>
                  </div>
                ) : null}
              </div>
            ) : (
              <div className="col-md-6 d-flex mb-2 align-items-center">
                <LabelField labelName={"Select Gender"} isRequired />
                <Dropdown
                  labelName={"Select Gender"}
                  placeholder={"Select Gender"}
                  setInputText={(value) => setGender(value)}
                  value={gender}
                  options={genderList}
                />
              </div>
            )}
          </>
        )}
        {popupTypesName?._id === 3 ? (
          <div className="col-md-8">
            {popupImageArr?.map((item, index) => (
              <div
                className="col-md-9 d-flex align-items-center mb-3"
                key={index}
              >
                <div className="col-md-5">
                  <ImagePickerAndViewer
                    isRequired
                    labelName={"Image for web"}
                    value={item.webImagePreview}
                    handleChange={(e) => handlePopupWebImageChange(e, index)}
                  />
                </div>

                <div className="col-md-5">
                  <ImagePickerAndViewer
                    isRequired
                    labelName={"Image for Mobile/App"}
                    value={item.appImagePreview}
                    handleChange={(e) => handlePopupAppImageChange(e, index)}
                  />
                </div>

                <div className="col-md-2 d-flex">
                  <label for="Order" className="fw-bold me-1 mb-0">
                    Order:
                  </label>

                  <input
                    type="text"
                    className="form-control col-2"
                    value={item.order}
                    onChange={(e) =>
                      onChangePopupImage(index, e.target.value, "order")
                    }
                  />

                  {popupImageArr.length > 1 && (
                    <HighlightOffIcon
                      className="cursor-pointer mt-2"
                      color="primary"
                      onClick={() => handleClosePopupImage(index)}
                    />
                  )}
                </div>
              </div>
            ))}

            <div className="d-flex justify-content-end">
              <AddMorebtn handleClick={onPressAddPopupImage} />
            </div>
          </div>
        ) : (
          <>
            {/* YOUR EXISTING IMAGE CODE — DON'T CHANGE */}

            <div className="col-md-6 d-flex justify-content-between">
              <ImagePickerAndViewer
                isRequired
                labelName={"Image for web"}
                value={selectedImageView}
                handleChange={(e) => handleLogoChange(e, 1)}
              />

              <ImagePickerAndViewer
                isRequired
                labelName={"Image for Mobile/App"}
                value={selectedImageMobilePrev}
                handleChange={(e) => handleChangeMobile(e, 1)}
              />
            </div>

            {popupTypesName?._id === 9 ? (
              <div className="col-md-6 d-flex justify-content-between">
                <ImagePickerAndViewer
                  isRequired
                  labelName={"Image for web 2"}
                  value={selectedImageView1}
                  handleChange={(e) => handleLogoChange(e, 2)}
                />

                <ImagePickerAndViewer
                  isRequired
                  labelName={"Image for Mobile/App 2"}
                  value={selectedImageMobilePrev1}
                  handleChange={(e) => handleChangeMobile(e, 2)}
                />
              </div>
            ) : null}
          </>
        )}
        <div className="col-md-6 d-flex align-items-center">
          <LabelField labelName={"Priority order"} isRequired={true} />
          <InputField
            placeholder={"Enter Priority order"}
            setInputText={(value) => onChangePriorityOrder(value)}
            value={priorityOrder}
            maxlength={length_Three}
            minlength={length_One}
          />
        </div>
        <div className="col-md-6 d-flex align-items-center ">
          <LabelField labelName={"Heading Text"} />
          <InputField
            placeholder={"Enter Heading Text"}
            setInputText={(value) => onChangeText("text", value)}
            value={headingText}
            maxlength={600}
            minlength={length_One}
          />
        </div>
        <div className="col-md-6 d-flex mb-2 justify-content-start align-items-center">
          <ToggleSwitchBtn
            labelName={"Status"}
            getToggleval={(value) => changeStatus(value)}
            isActive={status}
            // Isrequired={true}
          />
        </div>
        {showsPrimarySecondaryColor ? (
          <>
            <div className="col-md-6 d-flex align-items-center ">
              <LabelField labelName={"Primary Color"} />
              <input
                type="color"
                value={primaryColor}
                onChange={(e) => onPrimaryColorPickerChange(e.target.value)}
              />
              <input
                type="text"
                className="form-control form-control-sm ms-2"
                style={{ maxWidth: "110px" }}
                value={primaryColorText}
                onChange={(e) => onPrimaryColorTextChange(e.target.value)}
                placeholder="#RRGGBB"
                maxLength={7}
              />
              {/* NEW: Cancel button for Primary Color */}
              <button
                type="button"
                className="btn btn-sm btn-outline-secondary ms-2"
                onClick={handleCancelPrimaryColor}
              >
                <DeleteForeverIcon color="error" fontSize="small" />
              </button>
            </div>
            <div className="col-md-6 mt-2 d-flex align-items-center ">
              <LabelField labelName={"Secondary Color"} />
              <input
                type="color"
                value={secondaryColor}
                onChange={(e) => onSecondaryColorPickerChange(e.target.value)}
              />
              <input
                type="text"
                className="form-control form-control-sm ms-2"
                style={{ maxWidth: "110px" }}
                value={secondaryColorText}
                onChange={(e) => onSecondaryColorTextChange(e.target.value)}
                placeholder="#RRGGBB"
                maxLength={7}
              />
              {/* NEW: Cancel button for Secondary Color */}
              <button
                type="button"
                className="btn btn-sm btn-outline-secondary ms-2"
                onClick={handleCancelSecondaryColor}
              >
                <DeleteForeverIcon color="error" fontSize="small" />
              </button>
            </div>
          </>
        ) : (
          ""
        )}
        {showsSpinnerColor && (
          <div className="col-md-6 mt-2 d-flex align-items-center ">
            <LabelField labelName={"Spinner Color"} />
            <div className="d-flex align-items-center flex-wrap">
              {spinnerColor.map((color, index) => (
                <div
                  className="d-flex align-items-center me-3 mb-1"
                  key={index}
                >
                  <input
                    type="color"
                    value={color}
                    onChange={(e) =>
                      onSpinnerColorPickerChange(index, e.target.value)
                    }
                  />
                  <input
                    type="text"
                    className="form-control form-control-sm ms-2"
                    style={{ maxWidth: "110px" }}
                    value={spinnerColorText[index]}
                    onChange={(e) =>
                      onSpinnerColorTextChange(index, e.target.value)
                    }
                    placeholder="#RRGGBB"
                    maxLength={7}
                  />
                  {/* NEW: Cancel button for this Spinner Color swatch */}
                  <button
                    type="button"
                    className="btn btn-sm btn-outline-secondary ms-2"
                    onClick={() => handleCancelSpinnerColor(index)}
                  >
                    <DeleteForeverIcon color="error" fontSize="small" />
                  </button>
                </div>
              ))}
            </div>
          </div>
        )}
      </div>
    );
  };
  const onChangeExamName = (value) => {
    setExamName(value);
    setParentCourseVal("");
    setParentCourseList([]);
    setSubExamList([]);
    setSubExamName("");
    setHeadingText("");
    setPopUrl("");
    setSelectedImageView("");
    setSelectedImageMobilePrev("");
    setSelectedType("");
    dispatch(
      getSubExam(
        {
          examTypeId: value._id,
        },
        (res) => {
          if (res?.data.length > 0) {
            setSubExamList(res.data);
          } else {
            dispatch(
              getParentCourseNew(`${value._id}`, (res) => {
                setParentCourseList(res);
              }),
            );
          }
        },
      ),
    );
  };
  const onChangeSubExam = (value) => {
    setSubExamName(value);
    dispatch(
      getParentCourseNew(`${examName._id}/${value._id}`, (res) => {
        setParentCourseList(res);
      }),
    );
  };
  const onChangeParentCourse = (value) => {
    setParentCourseVal(value);
  };
  const onChangePriorityOrder = (value) => {
    if (!validateIsNumberOnly(value)) {
      setPriorityOrder(value);
    } else {
      dispatch(showErrorSnackbar("Only Numbers are allowed!"));
      return;
    }
  };
  const onPopUpChange = (value) => {
    setPopupTypesName(value);
    setStateId(true);
    setGender("");
    setSelectedState([]);
    setStatesList((prev) =>
      prev.map((s) => ({
        ...s,
        isSelected: false,
      })),
    );
  };

  const handleLogoChange = (e, index) => {
    e.preventDefault();
    if (!validateIsFileImageType(e)) {
      dispatch(showErrorSnackbar(validateIsFileImageTypeErrMsg));
      return;
    }
    if (e.target.files[0].size > pdf_size_1MB) {
      dispatch(showErrorSnackbar("File size should be less than 1 MB!!!"));
    } else {
      const reader = new FileReader();
      const file = e.target.files[0];
      reader.onloadend = () => {
        if (index === 1) {
          setSelectedImageView(reader.result);
        } else if (index === 2) {
          setSelectedImageView1(reader.result);
        }
        // setSelectedImageView(reader.result);
      };
      reader.readAsDataURL(file);
      dispatch(
        uploadPopupImg(file, (resCover) => {
          if (resCover) {
            if (index === 1) {
              setSelectedImage(resCover?.fullPath);
            } else if (index === 2) {
              setSelectedImage1(resCover?.fullPath);
            }
            // setSelectedImage(resCover?.fullPath);
          } else {
            dispatch(showErrorSnackbar("File Not Uploaded"));
          }
        }),
      );
    }
  };
  const handleChangeMobile = (e, index) => {
    e.preventDefault();
    if (!validateIsFileImageType(e)) {
      dispatch(showErrorSnackbar(validateIsFileImageTypeErrMsg));
      return;
    }

    const file = e.target.files[0];
    if (!file) return;

    if (file.size > pdf_size_1MB) {
      dispatch(showErrorSnackbar("File size should be less than 1 MB!!!"));
      return;
    }

    const reader = new FileReader();
    reader.onloadend = () => {
      if (index === 1) {
        setSelectedImageMobilePrev(reader.result);
      } else if (index === 2) {
        setSelectedImageMobilePrev1(reader.result);
      }
      // setSelectedImageMobilePrev(reader.result);
    };
    reader.readAsDataURL(file);

    dispatch(
      uploadPopupImg(file, (resCover) => {
        if (resCover) {
          if (index === 1) {
            setSelectedImageMobile(resCover?.fullPath);
          } else if (index === 2) {
            setSelectedImageMobile1(resCover?.fullPath);
          }
          // setSelectedImageMobile(resCover?.fullPath);
        } else {
          dispatch(showErrorSnackbar("File Not Uploaded"));
        }
      }),
    );
  };
  const changePaidUser = (event) => {
    if (event.target.checked) {
      setPaidUser(true);
    } else {
      setPaidUser(false);
    }
  };
  const changeStatus = (event) => {
    if (event.target.checked) {
      setStatus(true);
    } else {
      setStatus(false);
    }
  };
  const changeStateId = (event) => {
    if (event.target.checked) {
      setStateId(true);
      setGender("");
    } else {
      setStateId(false);
      setSelectedState([]);
      setStatesList((prev) =>
        prev.map((s) => ({
          ...s,
          isSelected: false,
        })),
      );
    }
  };

  const handleSubmit = (e) => {
    e.preventDefault();
    let reqBody = {
      type: popupTypesName?.type,
      priorityOrder: priorityOrder,
      status: status ? 1 : 0,
      visibility:
        popupTypesName?._id === 4
          ? selectedType?._id
          : popupTypesName?._id === 5 || popupTypesName?._id === 6
            ? 1
            : 3,
    };

    // Images: array only for type 3, flat fields for all other types
    if (popupTypesName?._id === 3) {
      reqBody.images = popupImageArr.map((item) => ({
        webImage: item.webImage,
        appImage: item.appImage,
        order: item.order,
      }));
    } else {
      reqBody.webImage = selectedImage;
      reqBody.appImage = selectedImageMobile;
      if (popupTypesName?._id === 9) {
        reqBody.webImage2 = selectedImage1;
        reqBody.appImage2 = selectedImageMobile1;
      }
    }

    if (headingText?.trim()) {
      reqBody.text = headingText?.trim();
    }
    if (showsPrimarySecondaryColor) {
      reqBody.primaryColor = primaryColor;
      reqBody.secondaryColor = secondaryColor;
    }
    if (showsSpinnerColor) {
      reqBody.spinnerColor = spinnerColor;
    }
    if (popupTypesName?._id === 3 || popupTypesName?._id === 7) {
      reqBody = {
        ...reqBody,
        examTypeId: examName?._id,
        baseCourseId: parentCourseVal?._id,
        url: popUrl,
        visibility: selectedType?._id,
      };
      if (subExamName) reqBody.subExamTypeId = subExamName._id;
    }
    if (popupTypesName?._id === 4) {
      if (selectedState.length > 0) {
        reqBody.stateId = selectedState;
      }
      if (gender) {
        reqBody.gender = gender?.name;
      }
    }
    dispatch(
      offerPopupAdd(reqBody, async () => {
        setPopupTypesName("");
        setParentCourseVal("");
        setExamName("");
        setHeadingText("");
        setPopUrl("");
        setPriorityOrder("");
        setSelectedImageView("");
        setSelectedImage("");
        setSelectedImageMobile("");
        setSelectedImageMobilePrev("");
        setSelectedImage("");
        setSelectedImageMobile("");
        setPaidUser(false);
        setStatus(false);
        setStateId(true);
        setGender("");
        setSelectedState([]);
        setPrimaryColor("");
        setPrimaryColorText("");
        setSecondaryColor("");
        setSecondaryColorText("");
        setSpinnerColor(["", "", ""]);
        setSpinnerColorText(["", "", ""]);
        setSelectedImage1("");
        setSelectedImageView1("");
        setSelectedImageMobile1("");
        setSelectedImageMobilePrev1("");

        setStatesList((prev) =>
          prev.map((s) => ({
            ...s,
            isSelected: false,
          })),
        );
      }),
    );
  };
  // const validations = () => {
  //   return (
  //     popupTypesName &&
  //     (![3, 7].includes(popupTypesName?._id) || examName) &&
  //     (![3, 7].includes(popupTypesName?._id) || parentCourseVal) &&
  //     ([3, 7].includes(popupTypesName?._id) ? popUrl?.trim() : true) &&
  //     //   headingText?.trim() &&
  //     priorityOrder?.trim() &&
  //     selectedImageMobile &&
  //     selectedImage
  //   );
  // };
  const validations = () => {
    return (
      popupTypesName &&
      (![3, 7].includes(popupTypesName?._id) || examName) &&
      (![3, 7].includes(popupTypesName?._id) || parentCourseVal) &&
      ([3, 7].includes(popupTypesName?._id) ? popUrl?.trim() : true) &&
      priorityOrder?.trim() &&
      (popupTypesName?._id === 3
        ? popupImageArr?.every(
            (item) => item?.webImage && item?.appImage && item?.order,
          )
        : selectedImageMobile && selectedImage)
    );
  };
  const onChangeText = (field, value) => {
    if (field === "text") {
      setHeadingText(value);
    }
    if (field === "url") {
      setPopUrl(value);
    }
  };
  return (
    <div>
      <div className="contentBox">
        <PageTitle name={"ADD ADD POP-UP"} />
        <div className="formDiv contentScrollbar">
          <div className="col-12 formWidth">
            <form onSubmit={handleSubmit}>
              {renderAddPopup()}
              <SubmitButton name="Submit" validations={!validations()} />
            </form>
          </div>
        </div>
      </div>
    </div>
  );
};

export default AddAllPopup;
